// Tamil
const dict = {
  // Brand / common
  "Every Win, Securely Paid.": "ஒவ்வொரு வெற்றிக்கும், பாதுகாப்பான பணம்.",
  "Loading Sara777": "Sara777 ஏற்றப்படுகிறது",
  "App version {version}": "ஆப் பதிப்பு {version}",
  "Language": "மொழி",
  "Home": "முகப்பு",
  "Account": "கணக்கு",
  "Wallet": "வாலட்",
  "History": "வரலாறு",
  "All Bids": "அனைத்து பந்தயங்கள்",
  "Profile": "சுயவிவரம்",
  "My Profile": "என் சுயவிவரம்",
  "Open menu": "மெனுவைத் திற",
  "Close menu": "மெனுவை மூடு",
  "Go back": "பின் செல்",
  "Back": "பின்",
  "Close": "க்ளோஸ்",
  "Open": "ஓப்பன்",
  "Submit": "சமர்ப்பி",
  "Cancel": "ரத்து செய்",
  "Continue": "தொடரவும்",
  "Update": "புதுப்பி",
  "Copy": "நகலெடு",
  "Change": "மாற்று",
  "Refresh": "புதுப்பி",
  "Date": "தேதி",
  "Status": "நிலை",
  "Action": "செயல்",
  "Remark": "குறிப்பு",
  "Amount": "தொகை",
  "Points": "புள்ளிகள்",
  "Bids": "பந்தயங்கள்",
  "Session": "அமர்வு",
  "Pending": "நிலுவையில்",
  "Failed": "தோல்வி",
  "Success": "வெற்றி",
  "optional": "விருப்பம்",
  "Since {date}": "{date} முதல்",

  // Sidebar
  "Account Statement": "கணக்கு அறிக்கை",
  "Game Rates": "விளையாட்டு விகிதங்கள்",
  "Terms & Conditions": "விதிமுறைகள் & நிபந்தனைகள்",
  "Video": "வீடியோ",
  "Logout": "வெளியேறு",
  "Privacy Policy": "தனியுரிமைக் கொள்கை",

  // Login / sign-up / MPIN / OTP
  "Login": "உள்நுழை",
  "Sign up": "பதிவு செய்",
  "New here?": "புதியவரா?",
  "Already have an account?": "ஏற்கனவே கணக்கு உள்ளதா?",
  "Have an account?": "கணக்கு உள்ளதா?",
  "Enter Number": "எண்ணை உள்ளிடவும்",
  "Enter your valid mobile number": "உங்கள் சரியான மொபைல் எண்ணை உள்ளிடவும்",
  "Mobile number": "மொபைல் எண்",
  "Mobile Number": "மொபைல் எண்",
  "Enter mobile number": "மொபைல் எண்ணை உள்ளிடவும்",
  "4-digit MPIN": "4 இலக்க MPIN",
  "Enter your 4-digit MPIN": "உங்கள் 4 இலக்க MPIN ஐ உள்ளிடவும்",
  "Show MPIN": "MPIN ஐக் காட்டு",
  "Hide MPIN": "MPIN ஐ மறை",
  "Create Account": "கணக்கை உருவாக்கு",
  "Create your new account": "உங்கள் புதிய கணக்கை உருவாக்கவும்",
  "Full name": "முழுப் பெயர்",
  "Email address (optional)": "மின்னஞ்சல் முகவரி (விருப்பம்)",
  "Create MPIN": "MPIN உருவாக்கு",
  "Set a 4-digit PIN to log in quickly": "விரைவாக உள்நுழைய 4 இலக்க PIN அமைக்கவும்",
  "Enter MPIN": "MPIN ஐ உள்ளிடவும்",
  "Confirm MPIN": "MPIN ஐ உறுதிப்படுத்தவும்",
  "{label} digit {n}": "{label} இலக்கம் {n}",
  "Never share your MPIN with anyone.": "உங்கள் MPIN ஐ யாருடனும் பகிர வேண்டாம்.",
  "MPINs match": "MPIN பொருந்துகிறது",
  "MPINs don't match. Try again.": "MPIN பொருந்தவில்லை. மீண்டும் முயற்சிக்கவும்.",
  "Enter your MPIN to login": "உள்நுழைய உங்கள் MPIN ஐ உள்ளிடவும்",
  "Enter OTP": "OTP ஐ உள்ளிடவும்",
  "Verify your mobile number": "உங்கள் மொபைல் எண்ணைச் சரிபார்க்கவும்",
  "Verify": "சரிபார்",

  // Home
  "Add Money": "பணம் சேர்",
  "Withdraw": "பணம் எடு",
  "Betting is Running Now": "பந்தயம் இப்போது நடைபெறுகிறது",
  "Betting is Closed for Today": "இன்று பந்தயம் மூடப்பட்டது",
  "Play {name}": "{name} விளையாடு",
  "{name} chart": "{name} சார்ட்",
  "Chart Info": "சார்ட் தகவல்",
  "Contact Support": "ஆதரவைத் தொடர்புகொள்ளவும்",
  "Jodi Chart": "ஜோடி சார்ட்",
  "Pana Chart": "பானா சார்ட்",
  "Past jodi results": "முந்தைய ஜோடி முடிவுகள்",
  "Past panna results": "முந்தைய பானா முடிவுகள்",
  "Call Now": "இப்போது அழைக்கவும்",
  "Talk to our support team": "எங்கள் ஆதரவுக் குழுவுடன் பேசுங்கள்",
  "WhatsApp": "வாட்ஸ்அப்",
  "Chat with us on WhatsApp": "வாட்ஸ்அப்பில் எங்களுடன் அரட்டையடிக்கவும்",

  // Game types
  "Select a game type to play": "விளையாட ஒரு விளையாட்டு வகையைத் தேர்ந்தெடுக்கவும்",
  "Single Digit": "சிங்கிள் டிஜிட்",
  "Single Digit Bulk": "சிங்கிள் டிஜிட் பல்க்",
  "Jodi Digit": "ஜோடி டிஜிட்",
  "Jodi Digit Bulk": "ஜோடி டிஜிட் பல்க்",
  "Single Pana": "சிங்கிள் பானா",
  "Single Pana Bulk": "சிங்கிள் பானா பல்க்",
  "Double Pana": "டபுள் பானா",
  "Double Pana Bulk": "டபுள் பானா பல்க்",
  "Triple Pana": "ட்ரிபிள் பானா",
  "Triple Pana Bulk": "ட்ரிபிள் பானா பல்க்",
  "Half Sangam": "ஹாஃப் சங்கம்",
  "Full Sangam": "ஃபுல் சங்கம்",
  "Jodi": "ஜோடி",
  "Single Panna": "சிங்கிள் பானா",
  "Double Panna": "டபுள் பானா",
  "Triple Panna": "ட்ரிபிள் பானா",
  "Tripple Panna": "ட்ரிபிள் பானா",

  // Playing
  "Enter points": "புள்ளிகளை உள்ளிடவும்",
  "Enter {label}": "{label} உள்ளிடவும்",
  "Add Bid": "பந்தயம் சேர்",
  "Submit Bid": "பந்தயத்தைச் சமர்ப்பி",
  "Pana": "பானா",
  "Digits": "இலக்கங்கள்",
  "Open Pana": "ஓப்பன் பானா",
  "Close Pana": "க்ளோஸ் பானா",
  "Open Digit": "ஓப்பன் டிஜிட்",
  "Close Digit": "க்ளோஸ் டிஜிட்",
  "No bids added yet": "இன்னும் பந்தயம் எதுவும் சேர்க்கப்படவில்லை",
  "Remove bid {number}": "பந்தயம் {number} ஐ நீக்கு",
  "Bid status": "பந்தய நிலை",
  "Note: Bid once played will not be cancelled": "குறிப்பு: ஒருமுறை வைத்த பந்தயம் ரத்து செய்யப்படாது",
  "HOLD": "காத்திருப்பு",
  "LOADING...": "ஏற்றப்படுகிறது...",
  "Failed !!": "தோல்வி !!",

  // Bids / history
  "Transaction ID": "பரிவர்த்தனை ID",
  "Placed": "வைக்கப்பட்டது",
  "No bid history found.": "பந்தய வரலாறு எதுவும் இல்லை.",
  "Balance": "இருப்பு",
  "No transactions yet": "இன்னும் பரிவர்த்தனைகள் இல்லை",
  "Deposit": "டெபாசிட்",
  "No history found.": "வரலாறு எதுவும் இல்லை.",
  "In Process": "செயலில் உள்ளது",
  "Declined": "நிராகரிக்கப்பட்டது",
  "User Withdrawal / deposit History": "பணம் எடுத்தல் / டெபாசிட் வரலாறு",

  // Charts
  "Bottom": "கீழே",
  "Back to top": "மேலே செல்",
  "Mon": "திங்",
  "Tue": "செவ்",
  "Wed": "புத",
  "Thu": "வியா",
  "Fri": "வெள்",
  "Sat": "சனி",
  "Sun": "ஞாயி",

  // Rates / how to play
  "Main game win ratio for all bids": "அனைத்து பந்தயங்களுக்கான முக்கிய வெற்றி விகிதம்",
  "{min} KA {max}": "{min} க்கு {max}",
  "How To Play": "எப்படி விளையாடுவது",
  "Download our application from Google Play Store or from our official website.": "எங்கள் ஆப்பை Google Play Store அல்லது எங்கள் அதிகாரப்பூர்வ இணையதளத்திலிருந்து பதிவிறக்கவும்.",
  "Register with your Mobile Number, Email ID, and User Name on our platform.": "உங்கள் மொபைல் எண், மின்னஞ்சல் ID மற்றும் பயனர் பெயருடன் எங்கள் தளத்தில் பதிவு செய்யவும்.",
  "Login to the application using your Mobile Number and MPIN.": "உங்கள் மொபைல் எண் மற்றும் MPIN மூலம் ஆப்பில் உள்நுழையவும்.",
  "Select the Game type, choose your favourite number, and start to play the game.": "விளையாட்டு வகையைத் தேர்ந்தெடுத்து, உங்களுக்குப் பிடித்த எண்ணைத் தேர்வு செய்து விளையாடத் தொடங்குங்கள்.",
  "Get a chance to win up to 10 Lac Points.": "10 லட்சம் புள்ளிகள் வரை வெல்லும் வாய்ப்பைப் பெறுங்கள்.",

  // Wallet
  "Add Fund": "நிதி சேர்",
  "Instant deposit via UPI / QR Code": "UPI / QR குறியீடு மூலம் உடனடி டெபாசிட்",
  "Manual Deposit": "கைமுறை டெபாசிட்",
  "Upload your payment screenshot": "உங்கள் பணம் செலுத்திய ஸ்கிரீன்ஷாட்டைப் பதிவேற்றவும்",
  "Withdraw Fund": "நிதி எடு",
  "Fast and secure withdrawal to bank": "வங்கிக்கு விரைவான, பாதுகாப்பான பணம் எடுத்தல்",
  "Deposit & Withdraw History": "டெபாசிட் & பணம் எடுத்தல் வரலாறு",
  "Check your past transactions statement": "உங்கள் முந்தைய பரிவர்த்தனை அறிக்கையைப் பார்க்கவும்",
  "Add Bank Details": "வங்கி விவரங்களைச் சேர்",
  "Update bank account for instant payouts": "உடனடி பணம் பெற வங்கிக் கணக்கைப் புதுப்பிக்கவும்",
  "Total Wallet Balance": "மொத்த வாலட் இருப்பு",
  "Pay": "செலுத்து",
  "Minimum deposit limit is {amount}.": "குறைந்தபட்ச டெபாசிட் வரம்பு {amount}.",
  "Enter withdraw points": "எடுக்க வேண்டிய புள்ளிகளை உள்ளிடவும்",
  "Amount is sent to your saved bank account.": "தொகை நீங்கள் சேமித்த வங்கிக் கணக்கிற்கு அனுப்பப்படும்.",
  "Update bank details": "வங்கி விவரங்களைப் புதுப்பி",
  "Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.": "கீழே உள்ள UPI ID க்குப் பணம் செலுத்தி, UTR எண்ணை உள்ளிட்டு, பணம் செலுத்திய ஸ்கிரீன்ஷாட்டைப் பதிவேற்றவும்.",
  "Enter amount": "தொகையை உள்ளிடவும்",
  "Pay to UPI ID": "இந்த UPI ID க்குச் செலுத்தவும்",
  "UTR Number": "UTR எண்",
  "Enter 12-digit UTR number": "12 இலக்க UTR எண்ணை உள்ளிடவும்",
  "Payment Screenshot": "பணம் செலுத்திய ஸ்கிரீன்ஷாட்",
  "Tap to upload screenshot": "ஸ்கிரீன்ஷாட்டைப் பதிவேற்ற தட்டவும்",
  "Tap to change": "மாற்ற தட்டவும்",
  "PNG or JPG": "PNG அல்லது JPG",
  "Bank Details": "வங்கி விவரங்கள்",
  "IFSC Code": "IFSC குறியீடு",
  "Account number": "கணக்கு எண்",
  "Bank name": "வங்கியின் பெயர்",
  "Account holder name": "கணக்கு வைத்திருப்பவர் பெயர்",
  "Google Pay number": "Google Pay எண்",
  "PhonePe number": "PhonePe எண்",
  "Paytm number": "Paytm எண்",

  // Profile
  "Edit profile": "சுயவிவரத்தைத் திருத்து",
  "Joined since": "சேர்ந்த தேதி",
  "Phone": "தொலைபேசி",
  "Wallet Balance": "வாலட் இருப்பு",
  "Update User Information": "பயனர் தகவலைப் புதுப்பி",
  "Name": "பெயர்",
  "Email": "மின்னஞ்சல்",
  "PhonePe": "PhonePe",
  "Google Pay": "Google Pay",
  "Paytm": "Paytm",
  "Name is required.": "பெயர் தேவை.",
  "Email is required.": "மின்னஞ்சல் தேவை.",
  "Email is invalid.": "மின்னஞ்சல் தவறானது.",
  "PhonePe number must be 10 digits.": "PhonePe எண் 10 இலக்கங்களாக இருக்க வேண்டும்.",
  "Paytm number must be 10 digits.": "Paytm எண் 10 இலக்கங்களாக இருக்க வேண்டும்.",
  "Google Pay number must be 10 digits.": "Google Pay எண் 10 இலக்கங்களாக இருக்க வேண்டும்.",

  // Pop-up messages
  "Enter User name !!": "பயனர் பெயரை உள்ளிடவும் !!",
  "Enter Valid mobile number !!": "சரியான மொபைல் எண்ணை உள்ளிடவும் !!",
  "Enter Valid email address !!": "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும் !!",
  "Enter your 4-digit MPIN !!": "உங்கள் 4 இலக்க MPIN ஐ உள்ளிடவும் !!",
  "Only 4 digit allow !!": "4 இலக்கங்கள் மட்டுமே அனுமதி !!",
  "Mpin does not match with confirm Mpin.": "MPIN உம் உறுதிப்படுத்தும் MPIN உம் பொருந்தவில்லை.",
  "This number is already registered. Please login.": "இந்த எண் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது. தயவுசெய்து உள்நுழையவும்.",
  "This number is not registered. Please create your account.": "இந்த எண் பதிவு செய்யப்படவில்லை. தயவுசெய்து உங்கள் கணக்கை உருவாக்கவும்.",
  "Unable to sign in. Please try again.": "உள்நுழைய முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  "Unable to continue. Please try again.": "தொடர முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  "Unable to create account. Please try again.": "கணக்கை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  "Api Error": "சர்வர் பிழை",
  "Something went wrong. Please try again.": "ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்.",
  "This Market Betting Is Closed For Today.": "இந்த மார்க்கெட்டில் இன்று பந்தயம் மூடப்பட்டது.",
  "Please Enter minimum 10 Points.": "குறைந்தது 10 புள்ளிகளை உள்ளிடவும்.",
  "Please Enter Points for Betting.": "பந்தயத்திற்கான புள்ளிகளை உள்ளிடவும்.",
  "Please Select Bids for Betting.": "பந்தயங்களைத் தேர்ந்தெடுக்கவும்.",
  "Please enter a valid Number.": "சரியான எண்ணை உள்ளிடவும்.",
  "Please Enter Amount first.": "முதலில் தொகையை உள்ளிடவும்.",
  "Please Enter UTR first.": "முதலில் UTR ஐ உள்ளிடவும்.",
  "Please select a valid image file.": "சரியான படக் கோப்பைத் தேர்ந்தெடுக்கவும்.",
  "UPI copied to clipboard!": "UPI கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது!",
  "Profile Updated Successfully.": "சுயவிவரம் வெற்றிகரமாகப் புதுப்பிக்கப்பட்டது.",
};

export default dict;
